module.exports = __webpack_public_path__ + "img/background.320caafd.png";